// extracted by mini-css-extract-plugin
export default {"signUp":"SignUpPage_signUp__tAgJF","container":"SignUpPage_container__dMOpp","signUp__title":"SignUpPage_signUp__title__xs1L7"};